import { useQuery } from '@tanstack/react-query'
import { mapsApi } from '@/api/maps'
import { queryKeys } from '@/config/queryConfig'
import { useAuthStore } from '@/store/authStore'

export function useMapConfig() {
  // /api/me/map-config/ is auth-protected. Firing it before login produces a 401,
  // and the global axios interceptor responds to a 401 with `window.location.href
  // = '/login'` — which would force a full-page reload of the very page we are
  // already on, creating an infinite redirect loop on /login. Gate the query on
  // auth state so it only runs once the user has tokens.
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return useQuery({
    queryKey: queryKeys.mapConfig.active('web'),
    queryFn: () => mapsApi.config('web'),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,   // 5 min — config rarely changes
    gcTime: 24 * 60 * 60 * 1000, // 24h
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
